import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./Lozenge.styled";
export var Lozenge = function (_a) {
    var _b = _a.appearance, appearance = _b === void 0 ? "default" : _b, _c = _a.isBold, isBold = _c === void 0 ? false : _c, _d = _a.isUpperCase, isUpperCase = _d === void 0 ? true : _d, customTextColor = _a.customTextColor, customBackgroundColor = _a.customBackgroundColor, children = _a.children;
    return (_jsx(S.Wrapper, { appearance: appearance, isBold: isBold, isUpperCase: isUpperCase, customTextColor: customTextColor, customBackgroundColor: customBackgroundColor, children: children }));
};
